import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { ActionType } from '../../../shared/models/table-column.model';

export const SKIP_CONFIRMATION = 'skip-confirmation';
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.html',
  styleUrls: ['./confirm-dialog.scss'],
  imports: [
    MatIcon,
    MatDialogModule,
    MatButton,
    TranslatePipe,
    MatCheckbox,
  ]
})
export class ConfirmDialogComponent {
  public readonly action = ActionType;
  public readonly data = inject(MAT_DIALOG_DATA);


  save(confirm: boolean): void {
    localStorage.setItem(SKIP_CONFIRMATION, confirm.toString());
  }

}
